// FONT AWESOME
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Brand icons
import {
  faCcMastercard,
  faCcVisa,
  faFacebookF,
  faTwitter,
  faInstagram,
} from '@fortawesome/free-brands-svg-icons';

library.add(
  faCcMastercard,
  faCcVisa,
  faFacebookF,
  faTwitter,
  faInstagram,
);

export default FontAwesomeIcon;
